import script from "./walletDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./walletDetail.vue?vue&type=script&setup=true&lang=js"

import "./walletDetail.vue?vue&type=style&index=0&id=c2585ee0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2585ee0"]])

export default __exports__